import { useState, useEffect } from 'react';
import axios from 'axios';
import { environment } from '../../../../environment/environment';
import toast from '../../../../utils/toast';

export interface AuditTrailEntry {
  actioned_by_name: string;
  date: string;
  action: string;
  updated_fields: Array<{
    name: string;
    old_value?: string;
    new_value?: string;
  }>;
}

export const useCompromisedEmployerAuditTrail = (employerId: number | null) => {
  const [data, setData] = useState<AuditTrailEntry[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    if (!employerId) {
      setData([]);
      setLoading(false);
    } else {
      const fetchAuditTrail = async () => {
        setLoading(true);
        try {
          const response = await axios.get<AuditTrailEntry[]>(
            `${environment.baseUrl}/employer/compromised-audit-trail/`,
            { params: { employer_id: employerId } }
          );
          if (!cancelled) {
            setData(response.data);
          }
        } catch (err: any) {
          if (!cancelled) {
            if (err.response?.status === 404) {
              setData([]);
            } else {
              toast.error('Failed to fetch audit trail');
              setData([]);
            }
          }
        } finally {
          if (!cancelled) {
            setLoading(false);
          }
        }
      };

      fetchAuditTrail();
    }

    return () => {
      cancelled = true;
    };
  }, [employerId]);

  return { data, loading };
};
